import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Text, { TEXT_SIZE, TEXT_COLOR, TEXT_WEIGHT } from '@components/Text';
import EmojiPickerButton from '@components/EmojiPickerButton';
import autoFeedback from '@shared/constants/autoFeedback';
import SectionLoading from '@components/SectionLoading';
import AutoFeedback from '../AutoFeedback';
import {
  Wrapper,
  HeaderContainer,
  StyledTextArea,
  PostButtonContainer,
  SubmissionActions,
  MeaningfulFeedbackControl,
  MeaningfulFeedbackCheckbox,
  StyledCTAButton,
} from './styles';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';

export class AutoFeedbackTextArea extends React.Component {
  constructor(props) {
    super(props);
    this.textAreaRef = React.createRef();
    this.state = {
      text: '',
      previousText: '',
      isMeaningful: false,
      previousIsMeaningful: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { externalText, hasError } = this.props;
    if (externalText !== prevProps.externalText) {
      this.setState({ text: externalText || '' });
      return;
    }

    if (hasError && !prevProps.hasError) {
      this.setState({
        text: this.state.previousText,
        isMeaningful: this.state.previousIsMeaningful,
      });
    }
  }

  onPostFeedbackClick = () => {
    const { onPostClicked } = this.props;
    const { text, isMeaningful } = this.state;
    onPostClicked(text, isMeaningful);
    this.setState({
      previousText: text,
      previousIsMeaningful: isMeaningful,
      text: '',
      isMeaningful: false,
    });
  };

  onMeaningfulChange = () => {
    this.setState((prevState) => ({ isMeaningful: !prevState.isMeaningful }));
  };

  onValueChange = (event) => {
    const { value } = event.target;
    this.setState({ text: value });
  };

  onFeedbackSelect = (text) => {
    this.setState((prevState) => ({ text: `${prevState.text}${text}` }));
  };

  onEmojiSelect = (emoji) => {
    const { text } = this.state;
    const textAreaNode = this.textAreaRef.current;
    const start = textAreaNode?.selectionStart ?? text.length;
    const end = textAreaNode?.selectionEnd ?? text.length;
    const nextText = `${text.slice(0, start)}${emoji}${text.slice(end)}`;
    const nextCursorPosition = start + emoji.length;

    this.setState(
      {
        text: nextText,
      },
      () => {
        if (this.textAreaRef.current) {
          this.textAreaRef.current.focus();
          this.textAreaRef.current.setSelectionRange(nextCursorPosition, nextCursorPosition);
        }
      }
    );
  };

  render() {
    const { text, isMeaningful } = this.state;
    const {
      disabled,
        t
    } = this.props;
    return (
      <Wrapper className='wrapper'>
        <HeaderContainer>
          <Text
            size={TEXT_SIZE.T1}
            textColor={TEXT_COLOR.DARK_BLUE}
            weight={TEXT_WEIGHT.BOLD}
          >
            {t('Common.UI.feedback')}
          </Text>
          <AutoFeedback
            dataTree={autoFeedback}
            onSelect={this.onFeedbackSelect}
            groupName='Group Name'
            boundariesElement='window'
          />
        </HeaderContainer>
        {disabled ? (
          <SectionLoading />
        ) : (
          <div>
            <StyledTextArea
              ref={this.textAreaRef}
              className='feedbackInput'
              placeholder={t('Common.Placeholders.leaveFeedback')}
              name='text'
              value={text}
              onChange={this.onValueChange}
            />
            <PostButtonContainer>
              <SubmissionActions>
                <EmojiPickerButton
                  onSelect={this.onEmojiSelect}
                />
                <MeaningfulFeedbackControl
                  control={(
                    <MeaningfulFeedbackCheckbox
                      checked={isMeaningful}
                      onChange={this.onMeaningfulChange}
                      size='small'
                    />
                  )}
                  label={t('Common.UI.meaningfulFeedback')}
                />
                <StyledCTAButton
                  className='postFeedbackButton'
                  action
                  disabled={disabled || _.isEmpty(this.state.text)}
                  onClick={this.onPostFeedbackClick}
                >
                  {t('Actions.Instance.submit')}
                </StyledCTAButton>
              </SubmissionActions>
            </PostButtonContainer>
          </div>
        )}
      </Wrapper>
    );
  }
}

AutoFeedbackTextArea.propTypes = {
  onPostClicked: PropTypes.func,
  externalText: PropTypes.string,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  t: PropTypes.func,
};

AutoFeedbackTextArea.defaultProps = {
  t: (label) => label,
};

export default compose(
    withTranslation()
)(AutoFeedbackTextArea);
